import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ProfileManagementService,
} from 'src/app/shared/service/store-management/profile-management/profile-management.service';
import { endpoints } from 'src/environments/environment';

@Injectable({
  providedIn: "root",
})
export class HierarchyService {
  private CUSTOMER_HIERARCHY = endpoints.customer_hierarchy;
  constructor(
    private http: HttpClient,
    private profileManagement: ProfileManagementService
  ) {}

  getHierarchy() {
    return this.http.get(`${this.CUSTOMER_HIERARCHY}${this.checkIfIsSales()}`);
  }

  checkIfIsSales() {
    const profile = this.profileManagement.getProfileByStore();
    return profile.isSales ? `/${profile.customerId}` : "";
  }
}
